import React from 'react'
import styles from './styles.module.scss'
import responsiveStyles from './responsiveStyles.module.scss'

// Icon components
const CrossIcon = () => (
    <div className={styles.iconCircle}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
    </div>
)

const PercentIcon = () => (
    <div className={styles.iconCircle}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <line x1="19" y1="5" x2="5" y2="19"></line>
            <circle cx="6.5" cy="6.5" r="2.5"></circle>
            <circle cx="17.5" cy="17.5" r="2.5"></circle>
        </svg>
    </div>
)

const CalendarIcon = () => (
    <div className={styles.iconCircle}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
            <line x1="16" y1="2" x2="16" y2="6"></line>
            <line x1="8" y1="2" x2="8" y2="6"></line>
            <line x1="3" y1="10" x2="21" y2="10"></line>
        </svg>
    </div>
)

const FrownIcon = () => (
    <div className={styles.iconCircle}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <circle cx="12" cy="12" r="10"></circle>
            <path d="M16 16s-1.5-2-4-2-4 2-4 2"></path>
            <line x1="9" y1="9" x2="9.01" y2="9"></line>
            <line x1="15" y1="9" x2="15.01" y2="9"></line>
        </svg>
    </div>
)

const MoneyIcon = () => (
    <div className={styles.iconCircle}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <rect x="2" y="6" width="20" height="12" rx="2" ry="2"></rect>
            <circle cx="12" cy="12" r="2"></circle>
            <path d="M6 12h.01M18 12h.01"></path>
        </svg>
    </div>
)

interface EligibilityCriterion {
    icon: React.ReactNode
    title: string
    description: string
}

const EligibilitySection: React.FC = () => {
    const criteria: EligibilityCriterion[] = [
        {
            icon: <CrossIcon />,
            title: 'Commissions',
            description: "You didn't know the broker or dealer would get a commission for your deal.",
        },
        {
            icon: <PercentIcon />,
            title: 'Interest rate',
            description: "You didn't know they could set or adjust the interest rate on your deal.",
        },
        {
            icon: <CalendarIcon />,
            title: 'Finance terms',
            description: "The terms of your agreement weren't clearly explained to you.",
        },
        {
            icon: <FrownIcon />,
            title: 'Duress',
            description: 'You felt pressure to agree to the deal.',
        },
        {
            icon: <MoneyIcon />,
            title: 'Fees & charges',
            description: "All the fees and charges weren't explained to you upfront.",
        },
    ]

    return (
        <div className={`${styles.eligibilitySection} ${responsiveStyles.eligibilitySection}`}>
            <div className={styles.container}>
                <h2 className={styles.title}>Are you eligible?</h2>
                <p className={styles.subtitle}>You could have a finance claim if any of these apply to you:</p>

                <div className={`${styles.criteriaContainer} ${responsiveStyles.criteriaContainer}`}>
                    {criteria.map((criterion, index) => (
                        <div
                            key={index}
                            className={`
                                ${styles.criterionCard}
                                ${responsiveStyles.criterionCard}
                            `}
                        >
                            <div className={styles.iconContainer}>{criterion.icon}</div>
                            <h3 className={styles.criterionTitle}>{criterion.title}</h3>
                            <p className={styles.criterionDescription}>{criterion.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default EligibilitySection
